<template>
   <div class="dropdown">
      <div class="label">{{label}}</div>
      <div :class="['selection',open?'openbox':'closebox',disabled?'disabled':'']"
         @click="openClose()"
         @focus="onFocus(label)"
         v-closable="{
            exclude: ['option'],
            handler: 'onClose'
         }"
         >
         {{ this.selection }}
         <i :class="['far fa-chevron-down fa-lg right rotate', open ? 'down' : '',]"></i>
      </div>
      <ul class="options" v-show="this.open">
         <li v-for="option in this.options"
            ref="option"
            :key = option
            class="selection option"
            @click="changeSelection(option)"
         >
         {{option}}
         </li>
      </ul>
   </div>
</template>

<script>
   import { mapStates, mapGetters, mapActions } from 'vuex'
   import Vue from 'vue'
   let handleOutsideClick

   Vue.directive('closable', {
      bind (el, binding, vnode) {
         // Here's the click/touchstart handler
         // (it is registered below)
         handleOutsideClick = (e) => {
            e.stopPropagation()
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
               // We only run this code if we haven't detected
               // any excluded element yet
               if (!clickedOnExcludedEl) {
                  // Get the element using the reference name
                  const excludedEl = vnode.context.$refs[refName]
                  // See if this excluded element
                  // is the same element the user just clicked on
                  clickedOnExcludedEl = excludedEl.includes(e.target)
               }
            })

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
               // If the clicked element is outside the dialog
               // and not the button, then call the outside-click handler
               // from the same component this directive is used in
               vnode.context[handler]()
            }
         }
         // Register click/touchstart event listeners on the whole page
         document.addEventListener('click', handleOutsideClick)
         document.addEventListener('touchstart', handleOutsideClick)
      },

      unbind () {
         // If the element that has v-closable is removed, then
         // unbind click/touchstart listeners from the whole page
         document.removeEventListener('click', handleOutsideClick)
         document.removeEventListener('touchstart', handleOutsideClick)
      }
   })

   export default {
      props: {
         //Label for the drop down box
         label:{
            type: String,
            required: false,
         },
         /*
         * array of objects which represents the options, the object must contain:
         * id (int), value (any)
         */
         options:{
            type: Array,
            required: true,
         },
         // enabled and disables the entire drop down box
         disabled: {
            type: Boolean,
            default: false,
         },
         // if true the first element of the dropdown will be the default, if not it will be blank
         override: {
            type: String,
         },
      },
      created: function(){
         if(this.override){
            this.changeSelection(this.override)
         }
      },
      data: function(){
         return {
            open: false,
            selection: "",
         }
      },
      computed: {
         //handles multiple drop down events
      },
      methods: {
         openClose(){
            this.open = !this.open;
            this.$emit('focus')
         },
         changeSelection(data){
            this.selection = data
            this.open = false;
            this.$emit('select', data)
         },
         onClose() {
            this.open = false;
         }
      },
      watch: {
         override: function (val){
            if(this.selection != this.override){
               this.changeSelection(this.override);
            }
         }
      }
   }
</script>

